/**
 * Vurderingsform-hjelper — parser `alternative_assessment_note`-feltet
 * fra backend og returnerer et menneske-lesbart label.
 *
 * Note-format fra `sensor-routes.js:1915`:
 *   `[ORAL] Muntlig vurdering\n\nBegrunnelse fra sensor:\n...`
 *
 * Mulige typer (fra `sensor-routes.js:1789`):
 *   oral | observation | practical | other
 */

const FORM_LABEL_NO: Record<string, string> = {
  ORAL: 'Muntlig',
  OBSERVATION: 'Observasjon',
  PRACTICAL: 'Praktisk',
  OTHER: 'Annet',
};

const FORM_LABEL_LONG_NO: Record<string, string> = {
  ORAL: 'Muntlig vurdering',
  OBSERVATION: 'Observasjonsvurdering',
  PRACTICAL: 'Praktisk vurdering',
  OTHER: 'Annen vurderingsform',
};

/**
 * Returner kompakt label (for badge): "Muntlig", "Observasjon", "Praktisk", "Annet".
 * Returnerer null hvis ingen eller ikke-registrert vurderingsform.
 */
export function parseAssessmentFormShort(note: string | null | undefined): string | null {
  if (!note) return null;
  const m = /^\[([A-Z]+)\]/.exec(note);
  if (!m) return null;
  return FORM_LABEL_NO[m[1]] || null;
}

/**
 * Returner langt label (for detaljvisning): "Muntlig vurdering" osv.
 */
export function parseAssessmentFormLong(note: string | null | undefined): string | null {
  if (!note) return null;
  const m = /^\[([A-Z]+)\]/.exec(note);
  if (!m) return null;
  return FORM_LABEL_LONG_NO[m[1]] || null;
}

/**
 * Farge-tokens for badge-visning. Alle former er likeverdige (per Kents
 * presisering 2026-10-02) — fargene differensierer kun for lesbarhet,
 * ikke for å antyde hierarki.
 */
export const ASSESSMENT_FORM_BADGE_COLORS: Record<string, string> = {
  ORAL: 'bg-blue-100 text-blue-700 border-blue-200',
  OBSERVATION: 'bg-amber-100 text-amber-700 border-amber-200',
  PRACTICAL: 'bg-teal-100 text-teal-700 border-teal-200',
  OTHER: 'bg-gray-100 text-gray-700 border-gray-200',
};

export function getAssessmentFormBadgeClass(note: string | null | undefined): string {
  if (!note) return '';
  const m = /^\[([A-Z]+)\]/.exec(note);
  if (!m) return '';
  return ASSESSMENT_FORM_BADGE_COLORS[m[1]] || '';
}
